<template>
 <div class="rechargeable">
    <div  style="overflow: auto; height: 90%;">
        <!-- 下拉刷新组件 -->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!-- 列表组件 -->
      <van-list v-model="loading" :finished="finished" :finished-text="bomTitle" @load="onLoad" :offset="20">
        <div class="list" v-if="list.length > 0">
          <div class="list_item b-b" v-for="(item, index) in list" :key="index">
            <div class="title" style="text-align: center;">{{item.title}}</div>
            <div class="cont"><span style="white-space:pre-wrap">{{item.message}}</span></div>
            <div v-if="item.createTime" class="cont_time">{{item.createTime}}</div>
        </div>
      </div>
        <div class="no_data" v-else>
          <div>
              <van-empty description="暂无数据" />
          </div>
        </div>
</van-list>
  </van-pull-refresh>
   </div>
<van-popup v-model="show" bind:close="onClose"  catchtouchmove='true' position="bottom" round closeable>
  <div class="alert">
    <div class="title">发布公告</div>
    <div class="tit">标题</div>
    <div class="input b">
      <!-- <input type="text" maxlength="40" placeholder="请输入标题" v-model="title" /> -->
      <van-field
        v-model="title"
        autosize
        type="text"
        maxlength="15"
        placeholder="请输入内容"
    />
    </div>
    <div class="tit">内容</div>
    <van-field
        v-model="message"
        rows="3"
        autosize
        type="textarea"
        maxlength="110"
        placeholder="请输入内容"
        show-word-limit
    />
    <div class="button" @click="release">保存</div>
  </div>
</van-popup>

<BackButton @back="setNotice" ><div class="notice_but">发布公告</div></BackButton>
</div>
</template>

<script>

import { getNotice,addNotice} from "@/api/notice.js";
import { checkStrNotNull } from "@/utils/common.js";


export default {
  name: "NoticePage",
  data() {
    return {
    
      pageNum: 1,
      total: 0,
      list: [],
      title: '',
      message: '',
      realMoney:'',
      show: false,
      remark: '',
      isLoading: false, // 控制下拉刷新的加载状态
      loading: false, // 控制上拉加载的加载状态
      finished: true, // 是否已加载完全部数据
      bomTitle: '', // 上拉加载完成时的文本
    };
  },
    created() {
      this.informPort(true) 
  },
  methods: {
    setNotice(){
      this.show = true
    },
      // 获取列表数据
    informPort(flag) {
      getNotice(this.pageNum).then(res => {
        console.log(res)
        if (res.code == 200 && res.rows) {
          console.log(res)
          let dataList = res.rows
          if (dataList && dataList.length) {
            if (flag) {
              this.list = dataList
            } else {
              this.list = [...this.list, ...dataList]
            }
          }
          this.total = res.total
          this.loading = false
          this.finished = false
          if (this.list.length >= this.total) {
            this.bomTitle = '到底了~ ' + '共计' + res.total + '条'
            this.finished = true
          } else {
            this.pageNum += 1
            this.bomTitle = ''
          }
        }
      })
    },
     // 下拉刷新
    onRefresh() {
      this.pageNum = 1
      this.finished = true
      this.loading = true
      this.list = []
      this.isLoading =true
      setTimeout(() => {
        this.isLoading = false // 结束下拉刷新的加载状态
        this.informPort(true) // 重新获取列表数据
        this.$toast.success('刷新成功')
      }, 300)
    },
    // 上拉加载
    onLoad() {
      this.informPort() 
      // 获取更多列表数据
      
    },

    release() {
      if(!checkStrNotNull(this.title)){
        this.$toast.fail({message: '标题不能为空'+this.minWithdrawal,duration: 3000})
        return;
      }
    if(!checkStrNotNull(this.message)){
      this.$toast.fail({message: '内容不能为空',duration: 3000})
      return;
    }
    let params = {
      title: this.title,
      message: this.message,
    }
    addNotice(params).then(res => {
      if (res.code != 200) {
        this.$toast.fail({message: res.msg,duration: 3000})
      }else{
        this.$toast.success({message: "操作成功",duration: 3000})
        this.show = false;
        this.title = '';
        this.message = '';
        setTimeout(() => {
          this.onRefresh();
        }, 2000)
      }
    })
  },
  },
};
</script>

<style lang="less" scoped>
.rechargeable {
   width: 100%;
   height: 100vh;
   background: url(@/assets/img/team_bg.png) no-repeat left center;
   background-size: 100% 100%;
   overflow: hidden;
}

.list {
  padding-bottom: 16px;
}
.list .list_item {
  align-items: center;
  padding: 10px 16px;
  background-color: #516388;
  margin-top: 2px;
  padding-bottom: 12px;
  color:#fff
}
.list .list_item .jiao {
  position: absolute;
  right: 0;
  top: 0;
}
.list .list_item .title {
  text-align: center;
    margin-bottom: 8px;
    font-weight: 700;
    margin-bottom: 8;
}
.list .list_item .cont {
    text-indent: 2em;
}
.list .list_item .cont_time {
    text-align: end;
    margin-top: 5px;
}


.no_data {
  margin-top: 10%;
  font-weight: 700;
}
.notice_but {
    color: #fff;
    font-weight: 700;
    background: url(@/assets/img/float_btn.png) no-repeat left center;
    background-size: 100% 100%;
    padding: 5px;
    border-radius: 10px;
}
.alert {
  padding: 12px 16px 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #fff;
  line-height: 16px;
}
.alert .title {
  font-size: 20px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  font-weight: 700;
}
 

::v-deep .van-cell {
  color: #fff;
  margin-top: 8px
}
::v-deep .van-popup{
  background-color: #151925;
}

.alert .input {
  margin-top: 8px;
}
.alert .input input{
 width: 100%
}




.alert .alert_item .placeholder {
  font-size: 16px;
  font-weight: 400;
  color: #BBBBBB;
}

.alert .button {
    background: #FA4743;
    border-radius: 8px;
    color: #fff;
    height: 46px;
    line-height: 46px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    width: 50%;
    margin: 0 auto;
    margin-top: 12px;
}
.alert .btn {
  display: flex;
  justify-content: space-between;
}
.alert .btn button {
  width: 45%;
}

.tit {
    margin-top: 8px;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
  }
</style>